/**
 * Vocabulary barrel — registers every plugin's locator vocabulary
 * with the host {@link locatorRegistry} at module-eval time.
 *
 * Adding a new plugin's vocabulary is two lines: import its data
 * file, register it under its plugin id. The host bootstraps this
 * module exactly once (see {@link GuideMeRoot}); registration is
 * idempotent so HMR re-evaluations don't duplicate.
 *
 * This file lives in the host (not in each plugin package) so:
 *   - vocabulary data ships in the host bundle, available
 *     synchronously when a tour resolves an alias
 *   - cross-package dependencies stay one-way (host → vocabulary
 *     data; plugins know nothing about Guide Me)
 *   - the UI engineer renaming a testid PRs a single file
 */

import { registerVocabulary } from '../locatorRegistry';
import { AGENT_HUB_LOCATORS } from './agent-hub';
import { IDENTITY_CORE_LOCATORS } from './identity-core';
import { SENTINEL_MANAGER_LOCATORS } from './sentinel-manager';

registerVocabulary('agent-hub', AGENT_HUB_LOCATORS);
registerVocabulary('identity-core', IDENTITY_CORE_LOCATORS);
registerVocabulary('sentinel-manager', SENTINEL_MANAGER_LOCATORS);
